import React, { FC } from 'react';
import { BoxProps } from '@material-ui/core';
import { Tooltip } from '../Tooltip';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';
import { SizeMapKeys, SpriteIcon } from 'src/config/api/models/FontAwesome';
import { useTheme } from '@material-ui/core';
import { StyledIconWrapper } from './Atoms';

export type DraggableItemFAIconVariant = 'primary' | 'secondary';

export type DraggableItemFAIconProps = BoxProps & {
  icon: SpriteIcon;
  left?: boolean;
  right?: boolean;
  size?: SizeMapKeys;
  tooltip?: string;
  variant?: DraggableItemFAIconVariant;
  backgroundColor?: string;
  foregroundColor?: string;
};

export const DraggableItemFAIcon: FC<DraggableItemFAIconProps> = ({
  icon,
  left,
  right,
  size,
  tooltip,
  variant,
  children,
  backgroundColor,
  foregroundColor,
  ...other
}: DraggableItemFAIconProps) => {
  const theme = useTheme();
  let background: string;
  let foreground: string;

  switch (variant) {
    case 'primary':
      background = theme.palette.primary.main;
      foreground = 'white';
      break;
    case 'secondary':
      background = '#fdfaf5';
      foreground = 'rgba(0, 0, 0, 0.3)';
      break;
    default:
      background = backgroundColor || '#fdfaf5';
      foreground = foregroundColor || 'rgba(0, 0, 0, 0.3)';
      break;
  }

  return (
    <StyledIconWrapper bgcolor={background} {...other}>
      {!!tooltip ? (
        <Tooltip title={tooltip} placement="top">
          <div style={{ lineHeight: 1 }}>
            <FontAwesomeSpriteIcon iconSize={size} icon={icon} color={foreground} />
          </div>
        </Tooltip>
      ) : (
        <FontAwesomeSpriteIcon icon={icon} iconSize={size} color={foreground} />
      )}
    </StyledIconWrapper>
  );
};
